import { Button, Dropdown, Flex } from 'antd'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import { Key } from 'react'
import useWindowSize from '../../../../../../hooks/window-size-hook'
import IconGlobalApp from '../../../../../../utils/IconGlobalApp'
import {
  isMenuDividerType,
  isGroupMenuType,
  isSubMenuType,
  isMenuItemType,
} from '../../../../../e-office-layout/components/dynamic-menu/helper/custom-menu-item-type-guard'
import {
  DetailMenuItemType,
  PROJECT_DETAIL_URL_PLACEHOLDER,
} from '../../../../constants/list-menu.quan-ly-giao-viec'
import cutFromString from '../../../../../../utils/cut-form-string'
import { mapCommonIcons } from '../../../../../../utils/mapCommonIcons'

interface IProps {
  detailMenuItems: DetailMenuItemType[]
}

const DetailMenuProject = ({ detailMenuItems }: IProps) => {
  const { projectId } = useParams()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { isSmallSize } = useWindowSize({ options: { needWindowSize: false } })

  const mapItem: Map<string, DetailMenuItemType> = new Map([])

  const projectDetailReplaceUrl = projectId
    ? cutFromString(pathname, projectId, true)
    : ''

  const convertKey = (key?: Key) =>
    key && key?.toString()?.includes(PROJECT_DETAIL_URL_PLACEHOLDER)
      ? key
          ?.toString()
          ?.replace(PROJECT_DETAIL_URL_PLACEHOLDER, projectDetailReplaceUrl)
      : key?.toString() || ''

  const convertKeyMenuItems: DetailMenuItemType[] = detailMenuItems.map(
    (item) => {
      const key = convertKey(item.key)
      const convertItem: DetailMenuItemType =
        isGroupMenuType(item) || isSubMenuType(item)
          ? {
              ...item,
              key,
              type: isSmallSize ? 'submenu' : item.type,
              children:
                item.children?.map((child) => {
                  const childKey = convertKey(child.key)
                  const convertChild: DetailMenuItemType = {
                    ...child,
                    key: childKey,
                  }

                  mapItem.set(
                    childKey,
                    isSmallSize &&
                      isMenuItemType(convertChild) &&
                      isSubMenuType(item)
                      ? { ...convertChild, icon: item.icon }
                      : convertChild
                  )

                  return convertChild
                }) || [],
            }
          : {
              ...item,
              key,
            }

      mapItem.set(key, convertItem)

      return convertItem
    }
  )

  const activeItem = mapItem.get(pathname)

  return isSmallSize ? (
    <Dropdown
      menu={{
        items: convertKeyMenuItems,
        onClick: ({ key }) => navigate(key),
        selectedKeys: [pathname],
      }}
      trigger={['click']}
    >
      <Button
        size="small"
        icon={
          !activeItem ||
          isMenuDividerType(activeItem) ||
          isGroupMenuType(activeItem)
            ? undefined
            : activeItem.icon
        }
      >
        {!activeItem || isMenuDividerType(activeItem) || !activeItem.label
          ? 'Menu'
          : activeItem.label}{' '}
        <IconGlobalApp name={mapCommonIcons.down} />
      </Button>
    </Dropdown>
  ) : (
    <Flex gap={8} wrap justify="end">
      {convertKeyMenuItems.map((item) => {
        if (isMenuDividerType(item) || isGroupMenuType(item)) return null

        if (isSubMenuType(item)) {
          const isActive =
            pathname.includes(item.key) ||
            item.children.some(
              ({ key }) => !!key && pathname.includes(key.toString())
            )

          const label = (() => {
            if (!isActive) return item.label
            if (
              !activeItem ||
              isMenuDividerType(activeItem) ||
              !activeItem.label
            )
              return item.label

            return activeItem.label
          })()

          return (
            <Dropdown
              key={item.key}
              menu={{
                items: item.children,
                onClick: ({ key }) => navigate(key),
                selectedKeys: [pathname],
              }}
              trigger={['click']}
            >
              <Button type={isActive ? 'primary' : 'default'} icon={item.icon}>
                {label} <IconGlobalApp name={mapCommonIcons.down} />
              </Button>
            </Dropdown>
          )
        }

        return (
          <Button
            key={item.key}
            type={
              pathname.includes(item.key?.toString() || '')
                ? 'primary'
                : 'default'
            }
            icon={item.icon}
            onClick={() => navigate(item.key?.toString() || '')}
          >
            {item.label}
          </Button>
        )
      })}
    </Flex>
  )
}

export default DetailMenuProject
